<template>
	<div class="loan">
		<div class="loan__col fields">
			<div class="fields__item field-input">
				<div class="field-input__label">Максимальная доступная сумма займа <strong>{{ data.free_loan_amount }}</strong> ₽ под <strong>{{ data.commission }}</strong>%</div>
				<input v-model="data.amount" type="text" id="amount" class="field-input__input" placeholder="Сумма">
			</div>
			<button
				@click="take()"
				:disabled="disableButton"
				type="submit" class="btn">
				Взять кредит
			</button>
		</div>
		<div class="loan__col">
			<div class="table" v-if="Object.keys(loans).length">
				<table>
					<thead>
						<tr>
							<th scope="col">Сумма</th>
							<th scope="col">Долг</th>
							<th scope="col">Закрыто</th>
							<th scope="col">Дата</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(loan) in loans">
							<td class="nowrap">
								{{ Number(loan.amount).toFixed(2) }} ₽
							</td>
							<td class="nowrap">
								{{ Number(loan.total).toFixed(2) }} ₽
							</td>
							<td class="nowrap">
								{{ Number(loan.covered).toFixed(2) }} ₽
							</td>
							<td class="nowrap">
								{{ loan.datetime }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="page-title" v-else>
				<h4>У вас нету открытых кредитов</h4>
			</div>
		</div>
	</div>
</template>

<script>

	import { mapState } from 'pinia';
	import { useUserStore } from './../../stores/User';

    export default {

        data() {
            return {
                loans: [],
                data: {
                    amount: '',
                    commission: 0,
                    max_loan: 0,
                    current_loan_amount: 0,
                    free_loan_amount: 0
                },
                isValid: true,
                disableButton: false
            }
        },
        mounted() {
            this.$root.isLoading = true;

            if(!this.user || !this.user.is_admin || !this.user.max_loan) {
                this.$root.isLoading = false;
                this.$router.go(-1);
            }
			setTimeout(this.get, 111);
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            validate() {
                this.isValid = true;
                this.disableButton = true;
                this.data.amount = Number(this.data.amount).toFixed(2);

                if(isNaN(this.data.amount) || this.data.amount > this.data.free_loan_amount) {
                    this.isValid = false;
                    this.$toast.error('Введите сумму не более ' + this.data.free_loan_amount);
                }

                this.disableButton = false;

                return this.isValid;
            },
            get() {
                this.$root.axios.get('/api/loans')
                .then(res => {
                    this.loans = res.data.loans;

                    this.data.current_loan_amount = res.data.current_loan_amount;
                    this.data.free_loan_amount = res.data.free_loan_amount;
                    this.data.max_loan = res.data.max_loan;
                    this.data.commission = res.data.loan_commission;
                })
				.finally(() => this.$root.isLoading = false)
            },
            take() {
                if(!this.validate()) return;

                this.$root.axios.post('/api/loans/take', this.data)
                .then(res => {
                    this.$toast.success(res.data.message);
                    this.user.balance = res.data.balance;

                    this.get();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
        }
    }
</script>
